module.exports = __webpack_public_path__ + "img/ic-back-arrow.95857202.svg";